import { render } from "./Modules.vue?vue&type=template&id=567a2822"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__